import React from 'react'
// import Particle from '../Particle';
import { Container, } from "react-bootstrap";
import { GoLocation } from 'react-icons/go';
import { BsTelephoneOutbound } from 'react-icons/bs';
import { MdOutlineEmail } from 'react-icons/md';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai';
AOS.init();
AOS.refreshHard();




function Contact() {

    return (

        <Container className="mb-5 contact" name="contacts">
            <h2 className="h1-responsive font-weight-bold text-center mb-5">Let's Talk</h2>
            <Container >
                <div className="row d-flex justify-content-center align-items-center mb-3">

                    <div className="col-md-6 mb-md-0 mb-5">
                        <form id="contact-form" name="contact-form" action="https://getform.io/f/572225df-8f2e-4305-a0f2-2a7b81a37309"
                            method="POST">

                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <div className="md-form mb-0">
                                        <input type="text" id="name" name="name" className="form-control" placeholder='Full Name' required autoComplete='off' />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <div className="md-form mb-0">
                                        <input type="number" id="number" name="number" className="form-control" placeholder='Mobile Number' required autoComplete='off' />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <div className="md-form mb-0">
                                        <input type="email" id="email" name="email" className="form-control" placeholder='Email  Address' required autoComplete='off' />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <div className="md-form">
                                        <textarea type="text" id="message" name="message" rows="8" className="form-control md-textarea" placeholder='Write your message . . . . .' required autoComplete='off'></textarea>
                                    </div>
                                </div>
                            </div>

                            <div className="text-center text-md-left">
                                <button className="btn btn-primary sendButton" type='submit'>Send</button>
                            </div>
                        </form>
                    </div>
                </div>


            </Container>
            <div className='row mt-3 d-flex justify-content-center align-items-center'>
                <div className="col-md-3 text-center">
                    <ul className="list-unstyled mb-0">
                        <li><i className="fas fa-map-marker-alt fa-2x"></i>
                            <p className='text-center d-flex justify-content-center align-items-center'><GoLocation style={{ marginRight: "4px", fontSize: "22px" }} /> Begusarai, BIHAR</p>
                        </li>

                        <li><i className="fas fa-phone mt-4 fa-2x"></i>
                            <a href="tel:+917061901868" className='emaildesign text-center d-flex justify-content-center align-items-center'><BsTelephoneOutbound style={{ marginRight: "8px", fontSize: "22px" }} /> +91 706 190 1868</a>
                        </li>

                        <li><i className="fas fa-envelope mt-4 fa-2x"></i>
                            <a href="mailto:ravi047raj@gmail.com" className='emaildesign text-center d-flex justify-content-center align-items-center'><MdOutlineEmail style={{ marginRight: "8px", fontSize: "22px" }} /> ravi047raj@gmail.com</a>
                        </li>

                        <li><i className="fas fa-envelope mt-4 fa-2x"></i>
                            <a href="https://github.com/Ravi-047" className='emaildesign text-center d-flex justify-content-center align-items-center'><AiFillGithub style={{ marginRight: "8px", fontSize: "22px" }} />Ravi-047</a>
                        </li>

                        <li><i className="fas fa-envelope mt-4 fa-2x"></i>
                            <a href="https://www.linkedin.com/in/ravi-ranjan-136844231/" className='emaildesign text-center d-flex justify-content-center align-items-center'><AiFillLinkedin style={{ marginRight: "8px", fontSize: "22px" }} />ravi-ranjan-136844231</a>
                        </li>
                    </ul>
                </div>
            </div>
        </Container>
    )
}

export default Contact